import Tween from "tween.ts"
import Animation from "../../../../../src/animation/Animation";


export default class ReduceOpacityAnim extends Animation {
  private Anim = Animation.getInstance();
  private isStopped = false;
  constructor(Element: any, onComp: () => void, resolve: () => void) {
    super();
    
    this.rootEventBus.on(this.EnumRootEventBus.cancelledCircleAnim, () => this.isStopped = true);

    if(this.Anim.getIsCancelled()) {
      onComp();
      return 
    };
    const o = {a:1}
    new Tween.Tween({...o})
      .to({ a: 0 }, 1500)
      .easing(Tween.Easing.Linear.None)
      .onUpdate(o => {
        if(this.isStopped){
          Element.alpha = 0;
          this.isStopped = true;
          resolve();
          return
        }
        Element.alpha = o.a;
      })
      .onComplete(() => onComp())
      .start();
  }
}